
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Form as ElForm } from 'element-ui'
import { getFixedProduct } from '@/api/product/product'
import { setProduct } from '@/api/merchant/product'

@Component({
  name: 'sub-product-fee-info',
  components: {}
})
export default class extends Vue {
  @Prop({ required: true }) subInfo!: any
  @Prop({ required: true }) merchant_no!: string
  @Prop({ default: '' }) merchantProductId!: string

  private back() {
    this.$emit('close', false)
  }

  private loading: boolean = false

  private infoForm: any = {
    extra_param: {
      product_sub_switch: 0,
      product_sub_rate_list: [
        {
          product_sub_code: '',
          rate_list: [],
          billing_type: '',
          billing_cycle: 0
        }
      ]
    }
  }
  // 当前子产品
  private currentProduct: any = {
    extra_param: {
      product_sub_switch: 0,
      product_sub_rate_list: [
        {
          product_sub_code: '',
          rate_list: [],
          billing_type: '',
          billing_cycle: 0
        }
      ]
    }
  }
  private activeNames: string | number = ''

  // 获取产品列表
  private async getProductlistData() {
    if (this.infoForm.product) {
      const data = {
        id: this.infoForm.product
      }
      await getFixedProduct(data).then((res: any) => {
        if (
          res.extra_param.product_sub_rate_list &&
          Array.isArray(res.extra_param.product_sub_rate_list)
        ) {
          // 添加安全检查，确保 infoForm.extra_param.product_sub_rate_list 存在
          if (
            this.infoForm.extra_param.product_sub_rate_list &&
            Array.isArray(this.infoForm.extra_param.product_sub_rate_list)
          ) {
            this.infoForm.extra_param.product_sub_rate_list.forEach(
              (infoItem: any) => {
                const resItem = res.extra_param.product_sub_rate_list.find(
                  (resItem: any) =>
                    resItem.product_sub_code === infoItem.product_sub_code
                )
                if (resItem && resItem.billing_type && resItem.billing_cycle) {
                  infoItem.billing_type = resItem.billing_type
                  infoItem.billing_cycle = resItem.billing_cycle
                }
              }
            )
          }
        }

        // 设置currentProduct
        this.currentProduct.extra_param.product_sub_rate_list =
          res.extra_param.product_sub_rate_list.map((item: any) => {
            return {
              ...item,
              billing_type: item.billing_type,
              billing_cycle: item.billing_cycle
            }
          })

        if (
          this.infoForm.extra_param &&
          this.infoForm.extra_param.product_sub_switch !== undefined &&
          this.infoForm.extra_param.product_sub_switch !== null &&
          (this.infoForm.extra_param.product_sub_switch === 0 ||
            this.infoForm.extra_param.product_sub_switch === 1) &&
          this.infoForm.extra_param.product_sub_rate_list &&
          this.infoForm.extra_param.product_sub_rate_list.length > 0
        ) {
          this.currentProduct = this.infoForm
          console.log(this.currentProduct, '执行1')
        }

        if (
          this.infoForm.extra_param &&
          (this.infoForm.extra_param.product_sub_switch === undefined ||
            this.infoForm.extra_param.product_sub_switch === null ||
            !this.infoForm.extra_param.product_sub_rate_list)
        ) {
          this.currentProduct = res
          console.log(this.currentProduct, '执行2')
        }
      })
    }
  }

  private addRateConfig(item: any) {
    if (!item.rate_list) {
      item.rate_list = []
    }
    const lastIndex = item.rate_list.length - 1
    let newMinAmount = 0
    if (lastIndex >= 0 && item.rate_list[lastIndex].max_amount) {
      newMinAmount = Number(item.rate_list[lastIndex].max_amount) + 1
    }

    item.rate_list.push({
      rate: 0,
      min_fee: 0,
      fixed_fee: 0,
      max_amount: newMinAmount + 100000,
      min_amount: newMinAmount
    })
  }

  private removeRateConfig(item: any, index: number) {
    // 确保rate_list存在
    if (item.rate_list && Array.isArray(item.rate_list)) {
      item.rate_list.splice(index, 1)
    }
  }

  private validateRateList(): boolean {
    // 确保product_sub_rate_list存在且为数组
    if (
      !this.currentProduct.extra_param.product_sub_rate_list ||
      !Array.isArray(this.currentProduct.extra_param.product_sub_rate_list)
    ) {
      return true // 如果没有配置则不验证
    }

    for (const product of this.currentProduct.extra_param
      .product_sub_rate_list) {
      // 确保rate_list存在且为数组
      if (!product.rate_list || !Array.isArray(product.rate_list)) {
        continue
      }

      for (let i = 0; i < product.rate_list.length; i++) {
        const current = product.rate_list[i]

        // 确保 max_amount >= min_amount
        if (Number(current.max_amount) < Number(current.min_amount)) {
          this.$message({
            message: this.$t('product.amount_range_error') as string,
            type: 'error'
          })
          return false
        }

        // 确保当前项 min_amount 比前一项 max_amount 大
        if (i > 0) {
          const previous = product.rate_list[i - 1]
          if (Number(current.min_amount) <= Number(previous.max_amount)) {
            this.$message({
              message: this.$t('product.amount_continuity_error') as string,
              type: 'error'
            })
            return false
          }
        }
      }
    }
    return true
  }

  private async submitData() {
    try {
      const isValid = this.validateRateList()
      if (!isValid) {
        return
      }
      this.loading = true
      const data = {
        id: this.infoForm.id,
        merchant_no: this.merchant_no,
        extra_param: {
          product_sub_switch: this.infoForm.extra_param.product_sub_switch,
          product_sub_rate_list:
            this.currentProduct.extra_param.product_sub_rate_list
        }
      }
      console.log(data.extra_param)
      await setProduct(data).then((res: any) => {
        this.$message({
          message: 'Save successful!',
          type: 'success'
        })
        this.loading = false
        this.back()
      })
    } catch (error) {
      this.loading = false
    }
  }

  private async init() {
    await this.getProductlistData()
  }

  mounted() {
    this.infoForm = this.subInfo
    console.log(this.infoForm.extra_param)
    if (this.infoForm) {
      this.init()
    }
  }
}
